import common from '@/i18n/pl/common.js';
import nav from '@/i18n/pl/nav.js';
import auth from '@/i18n/pl/auth.js';
import settings from '@/i18n/pl/settings.js';
import start from '@/i18n/pl/start.js';
import tools from '@/i18n/pl/tools.js';
import planner from '@/i18n/pl/planner.js';
import entry from '@/i18n/pl/entry.js';
import food from '@/i18n/pl/food.js';
import forma from '@/i18n/pl/forma.js';
import shopping from '@/i18n/pl/shopping.js';
import basket from '@/i18n/pl/basket.js';
import finance from '@/i18n/pl/finance.js';
import wallet from '@/i18n/pl/wallet.js';
import projects from '@/i18n/pl/projects.js';
import notes from '@/i18n/pl/notes.js';
import places from '@/i18n/pl/places.js';
import assistant from '@/i18n/pl/assistant.js';
import people from '@/i18n/pl/people.js';
import pets from '@/i18n/pl/pets.js';
import devices from '@/i18n/pl/devices.js';
import cares from '@/i18n/pl/cares.js';
import habits from '@/i18n/pl/habits.js';
import medications from '@/i18n/pl/medications.js';
import admin from '@/i18n/pl/admin.js';

export default { admin, assistant, common, nav, auth, settings, start, tools, planner, entry, food, forma, shopping, basket, finance, wallet, projects, notes, places, people, pets, devices, cares, habits, medications };
